import React from 'react'
import axios from 'axios'
import {
    Redirect
} from "react-router-dom"
import io from "socket.io-client"
import ContactAndLegals from '../Components/ContactAndLegals'
import News from '../Components/News'

import ReactGA from 'react-ga'
import MdCalendar from 'react-ionicons/lib/MdCalendar'
import IosContact from 'react-ionicons/lib/IosContact'
import IosPowerOutline from 'react-ionicons/lib/IosPowerOutline'
import IosVideocam from 'react-ionicons/lib/IosVideocam'

import PupilDashboard from '../Containers/PupilDashboard'
import TeacherDashboard from '../Containers/TeacherDashboard'

import { getCookie, add_days } from '../functions/functions.js'

import { ScaleLoader } from 'react-spinners';


import '../css/dashboard.css'

import toque from '../files/images/toque.png'
import logo from '../files/images/logo.png'


export default class Dashboard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            auth: {},
            thumbnail: "main",
            showNumber: false,
            showEmail: false,
            cantLogin: 0,
        }

        this.getProfile = this.getProfile.bind(this)
        this.getAvatar = this.getAvatar.bind(this)
        this.getPendingOrders = this.getPendingOrders.bind(this)
    }

    componentDidMount() {
        window.scrollTo(0, 0)
        let email = getCookie("user")
        let token = getCookie("token")
        let pwd = getCookie("password")
        this.setState({ auth: { email: email, token: token, password: pwd } }, () => {
            this.getProfile();
            this.fetchUnreadNews();
        })
    }

    componentWillUnmount() {
        if (this.state.socket) {
            this.state.socket.disconnect();
        }
    }

    getProfile(refresh = "all") {
        const headers = {
            'Content-Type': 'application/json',
            'id': this.state.auth.email,
            'authorization': this.state.auth.token
        }
        axios.get(this.props.apiAddress + '/v2/profile',
            { headers: headers })
            .then((doc) => {
                this.setState({ userType: doc.data.type, userData: doc.data, gotAPIResponse: true }, () => this.getAvatar())
                ReactGA.pageview("dashboard(" + this.state.userType + ")")
                if (refresh === "all") {
                    this.getTopicAndLevels()
                    if (doc.data.level) {
                        this.setState({
                            level: {
                                _id: doc.data.level._id,
                                name: doc.data.level.name,
                                price: doc.data.level.price,
                                remotePrice: doc.data.level.remotePrice
                            }
                        })
                    }
                }
                // Init socket for both if not already exists
                if (!this.state.socket) {
                    const socket = io(this.props.apiAddress, {
                        auth: {
                            token: this.state.auth.token,
                            id: this.state.auth.email
                        },
                        transports: ['websocket']
                    });

                    this.setState({ socket });

                    if (doc.data.type === 'teacher') {
                        socket.on('orders:new', (newOrder) => {
                            this.setState(prevState => {
                                if (!prevState.pendingOrders) return { pendingOrders: [newOrder] };
                                // Check for duplicate
                                if (prevState.pendingOrders.some(o => o._id === newOrder._id)) return null;
                                return { pendingOrders: [newOrder, ...prevState.pendingOrders] };
                            });
                        });

                        socket.on('orders:removed', ({ _id }) => {
                            this.setState(prevState => {
                                if (!prevState.pendingOrders) return null;
                                return { pendingOrders: prevState.pendingOrders.filter(o => o._id !== _id) };
                            });
                        });

                        socket.on('orders:update', (updatedOrder) => {
                            this.setState(prevState => {
                                if (!prevState.pendingOrders) return null;
                                return { pendingOrders: prevState.pendingOrders.map(o => o._id === updatedOrder._id ? updatedOrder : o) };
                            });
                        });
                    }
                } else if (doc.data.type === 'teacher' && !this.state.pendingOrders) {
                    // If socket exists but we re-fetched profile and verified it's a teacher, make sure we have pending orders logic?
                    // Actually the listeners are attached to the socket instance. Functional closures might be stale if using hooks, but this is a Class component.
                    // The listeners use `this.setState`, which is bound to the instance. So it should be fine.
                    // Just ensure we fetch pending orders.
                    this.getPendingOrders();
                }

                if (doc.data.type === 'teacher' && !this.state.pendingOrders) {
                    this.getPendingOrders();
                }
            })
            .catch((err) => {
                console.log(err)
                if (this.state.cantLogin > 3) {
                    this.setState({ redirect: "login" })
                } else {
                    this.setState((state) => {
                        return { ...state, cantLogin: 1 + state.cantLogin }
                    }, this.getProfile)
                }
            })
    }

    getAvatar() {
        const headers = {
            'response-type': 'arraybuffer',
            'key': 'hello',
            'token': this.state.auth.token,
            'id': this.state.auth.email
        }

        axios.get(this.props.apiAddress + "/getPicture", { headers: headers })
            .then((res) => {
                const rawPicture = res.data.data
                let img64 = null
                if (rawPicture) {
                    if (rawPicture.startsWith('http') || rawPicture.startsWith('data:')) {
                        img64 = rawPicture
                    } else {
                        img64 = 'data:image/png;charset=utf-8;base64, ' + rawPicture
                    }
                }
                this.setState({ userData: { ...this.state.userData, avatar: img64 } })
            }).catch(function (err) {
                console.log(err)
            });
    }

    getTopicAndLevels() {
        let headers = {
            'Content-Type': 'application/json',
            'id': this.state.auth.email,
            'authorization': this.state.auth.token
        }
        axios.get(this.props.apiAddress + '/levels',
            { headers: headers })
            .then((res) => {
                let levels = res.data
                let formated = []
                for (let i in levels) {
                    formated.push({
                        _id: levels[i]._id,
                        name: levels[i].name,
                        price: levels[i].price,
                        remotePrice: levels[i].remotePrice,
                    })
                }
                this.setState({ levels: formated })
                //this.createSelectLevelMenu(formated)
            }).catch(function (err) {
                console.log(err);
            });

        headers = {
            'Content-Type': 'application/json',
            'authorization': this.state.auth.email
        }
        axios.get(this.props.apiAddress + '/topics',
            { headers: headers })
            .then((res) => {
                let topics = res.data
                let formated = []
                let reversed = {}
                for (let i in topics) {
                    formated.push({
                        _id: topics[i]._id,
                        name: topics[i].name
                    })
                    reversed[topics[i]._id] = topics[i].name
                }
                this.setState({ topics: formated })
                //this.createSelectTopicMenu(formated)
            }).catch(function (err) {
                console.log(err);
            });
    }

    getPendingOrders() {
        let headers = {
            'Content-Type': 'application/json',
            'id': this.state.auth.email,
            'authorization': this.state.auth.token
        }
        axios.get(this.props.apiAddress + '/v2/orders/pending',
            { headers: headers })
            .then((doc) => {
                this.setState({ pendingOrders: doc.data })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    setThumbnail(thbnl) {
        this.setState({ thumbnail: thbnl })
    }

    logout() {
        this.setState({ redirect: "/login" })
        document.cookie = "loggedIn=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
        document.cookie = "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
        document.cookie = "password=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
        document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
    }

    renderPassCTA = (subscription) => {
        let color = subscription?.status === 'active' ? 'green' : 'yellow';
        let text = subscription?.status === 'active' ? 'Abonnement actif' : 'Pas d\'abonnement';

        return (
            <button
                id='pass-status-btn'
                onClick={() => this.setState({ redirect: '/dashboard/passes', thumbnail: 'userData' })}
                className={'btn ' + color + ' lg rounded'}>
                {text}
            </button>
        )
    }

    fetchUnreadNews = () => {
        const headers = {
            'Content-Type': 'application/json',
            'id': this.state.auth.email,
            'authorization': this.state.auth.token
        };
        axios.get(this.props.apiAddress + '/v2/news/unread', { headers })
            .then(res => this.setState({ unreadNews: res.data.news || 0 }))
            .catch(err => console.log('Error fetching unread news', err));
    }

    openNews = () => {
        this.setState({ showNews: true, unreadNews: 0 });
    }

    closeNews = () => {
        this.setState({ showNews: false });
    }

    render() {
        return (
            <div className="dashboard-container">
                <div className="dshbd-bg">
                    <img src={require(this.state.userType === "pupil" ? "../files/images/eleve-assis.png" : "../files/images/prof-visio.png")}
                        alt=''
                        style={this.state.userType === "pupil" ?
                            {
                                position: 'fixed',
                                bottom: 0,
                                right: 0,
                                width: '50vw',
                            }
                            :
                            {
                                position: 'fixed',
                                bottom: 0,
                                left: 0,
                                width: '50vw',
                            }
                        } />
                </div>
                {this.state.redirect && <Redirect to={this.state.redirect} />}
                {this.state.cantLogin > 1 ? <div style={{ position: 'absolute', top: "30vh", height: "40vh" }}>Erreur: vérifiez votre connexion internet. Si l'erreur persiste, nous allons vous rediriger vers la page de connexion.</div> : null}
                <div className="dshbd-band head">
                    <div className="row" style={{ alignItems: 'center' }}>
                        <button className="btn transparent" onClick={() => this.setState({ thumbnail: 'main' })}>
                            <img
                                alt=""
                                className={this.state.thumbnail === 'main' ? "logo foot icon active" : "logo foot icon inactive"}
                                src={logo}
                            />
                        </button>
                        <ContactAndLegals relativePosition horizontalLayout white noLegals />
                    </div>
                    {/*this.state.userType === "teacher" &&
                    <a className='btn green row sm rounded' id="visio-shortcut" href={`https://whereby.com/emp-${this.state.auth.email}`} target="_blank" rel="noopener noreferrer">
                    <p style={{fontSize: '1.1em'}}>Accéder à la visio&nbsp;</p>
                    <IosVideocam
                    color={'#fff'}
                    title={'Visio'}
                    style={{cursor: "pointer", marginTop: '2px'}}
                    fontSize="25px"
                />
            </a>
            */}
                    <div className="row" style={{ justifyContent: 'space-between', alignItems: 'center', flex: 1, marginLeft: '50%' }}>
                        {this.state.userData && this.state.userType === "pupil" && this.renderPassCTA(this.state.userData.subscription)}
                        <button
                            id='news-btn'
                            onClick={this.openNews}
                            className='btn yellow lg rounded'
                            style={{ marginRight: '10px', position: 'relative' }}>
                            News
                            {this.state.unreadNews > 0 && (
                                <span style={{
                                    position: 'absolute', top: -5, right: -5,
                                    backgroundColor: 'var(--error)', color: 'white',
                                    borderRadius: '50%', width: 20, height: 20,
                                    fontSize: 11, fontWeight: 'bold',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>
                                    {this.state.unreadNews >= 10 ? '9+' : this.state.unreadNews}
                                </span>
                            )}
                        </button>
                        <div id="logout" style={{ alignItems: 'center' }}>
                            <IosPowerOutline
                                onClick={() => this.logout()}
                                fontSize="25px"
                                style={{ cursor: "pointer" }}
                                color="#fff"
                            />
                            {/*}<p className="tooltip">Déconnexion</p>*/}
                        </div>
                    </div>
                </div>

                <div className="dshbd-body">
                    {this.state.auth.token !== "" ?
                        this.state.gotAPIResponse && this.state.levels && this.state.topics ?
                            this.state.userType === "pupil" ?
                                <PupilDashboard
                                    auth={this.state.auth}
                                    utility={{ topics: this.state.topics, levels: this.state.levels }}
                                    userData={this.state.userData}
                                    apiAddress={this.props.apiAddress}
                                    updateData={this.getProfile}
                                    thumbnail={this.state.thumbnail}
                                    setThumbnail={(t) => this.setThumbnail(t)}
                                    socket={this.state.socket}
                                />
                                :
                                <TeacherDashboard
                                    auth={this.state.auth}
                                    utility={{ topics: this.state.topics, levels: this.state.levels }}
                                    userData={this.state.userData}
                                    apiAddress={this.props.apiAddress}
                                    updateData={this.getProfile}
                                    thumbnail={this.state.thumbnail}
                                    setThumbnail={(t) => this.setThumbnail(t)}
                                    pendingOrders={this.state.pendingOrders}
                                    getPendingOrders={this.getPendingOrders}
                                    socket={this.state.socket}
                                />
                            :
                            <div className={' loader'}>
                                <ScaleLoader
                                    className={' loader'}
                                    sizeUnit={"px"}
                                    height={30}
                                    width={5}
                                    color={'#4080ff'}
                                    loading={true}
                                />
                            </div>
                        :
                        <Redirect to="/login" />
                    }
                </div>
                <div className="dshbd-band foot">
                    <MdCalendar
                        onClick={() => this.setState({ thumbnail: 'courses' })}
                        fontSize="35px"
                        style={{ cursor: "pointer" }}
                        color={this.state.thumbnail === 'courses' ? "#ffffff" : "#999"} />
                    <img
                        alt=""
                        className={this.state.thumbnail === 'main' ? "foot icon active" : "foot icon inactive"}
                        src={toque}
                        onClick={() => this.setState({ thumbnail: 'main' })} />
                    <IosContact
                        onClick={() => this.setState({ thumbnail: 'userData' })}
                        fontSize="35px"
                        style={{ cursor: "pointer" }}
                        color={this.state.thumbnail === 'userData' ? "#ffffff" : "#999"} />
                </div>

                <News visible={this.state.showNews} onClose={this.closeNews} />
            </div>
        )
    }
}
